import { styled } from "@mui/system";
import { FiMinusCircle, FiPlusCircle } from "react-icons/fi";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";

export const NotesStyle = {
  display: "flex",
  justifyContent: "start",
  marginLeft: "2rem",
  marginRight: "2rem",
};

export const InputHeader = {
  display: "flex",
  flexDirection: "column",
};

export const NotesTextFieldStyle = (width: boolean, multiline?: boolean) => ({
  borderRadius: "0.0625rem",
  borderColor: colors.black[13],
  width: width ? "12rem" : "100%",
  height: multiline ? "7.2rem" : "2.4rem",
  "& .MuiOutlinedInput-root": {
    height: multiline ? "7.2rem" : "2.4rem",
    "& input": {
      marginLeft: "0.7rem",
      height: multiline ? "7.2rem" : "2.4rem",
      borderRadius: "0.0625rem",
      padding: "0",
      fontSize: "0.8rem",
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.portalColor[16],
      border: `3px solid ${colors.portalColor[16]}`,
    },
    "&.Mui-disabled": {
      backgroundColor: colors.grey[4],
    },
    "&.Mui-error fieldset": {
      borderColor: colors.grey[4],
    },
  },
});


export const ReviewTabNote = () => ({
  marginX: "1rem",
  marginTop: "2rem",
  wordBreak: "break-word",
});

export const PhysicianNameStyle = () => ({
  marginY: "1rem",
});

export const Pad = {
  padding: "1rem",
};

export const AuthPeriodTablecell = () => ({
  marginBottom: "0.6rem",
  textAlign: "center",
});

export const TotalTablecell = () => ({
  width: "26%",
  paddingLeft: "2rem",
  fontWeight: fontWeight[4],
});

export const VisitCountTablecell = () => ({
  textAlign: "center",
  fontWeight: fontWeight[4],
});

export const TotalVisitCount = () => ({
  textAlign: "center",
  fontWeight: fontWeight[4],
});

export const TextHeaderStartMedium = {
  textAlign: "center",
  fontSize: "medium",
};

export const TableHeaderStyle = {
  backgroundColor: colors.backgroundColor[8],
  borderRadius: "15px",
  borderBottom: "none",
  borderTop: "none",
  "& th:first-of-type": {
    borderTopLeftRadius: "12px",
    borderBottomLeftRadius: "12px",
    borderBottom: "none",
    borderTop: "none",
  },
  "& th:last-of-type": {
    borderTopRightRadius: "12px",
    borderBottomRightRadius: "12px",
    borderBottom: "none",
    borderTop: "none",
  },
  "& th": {
    borderBottom: "none",
    borderTop: "none",
  },
};

export const RadioGroupStyle = {
  "& .MuiFormControlLabel-label": {
    fontSize: "1rem",
    fontWeight: fontWeight[4],
  },
  "& .MuiRadio-root": {
    color: colors.primary.main,
    fontSize: "1.25rem",
  },
};

export const FiMinusCircleIcon: any = styled(FiMinusCircle as React.ComponentType)<{ editable?: boolean }>(({ editable }) => ({
  color: editable ? colors.primary.main : colors.fonts[5],
}));
export const FiPlusCircleIcon: any = styled(FiPlusCircle as React.ComponentType)<{ editable?: boolean }>(({ editable }) => ({
  color: editable ? colors.primary.main : colors.fonts[5],
}));

export const verticleDivider = {
  borderLeft: `2px solid ${colors.borders[1]}`,
  height: "100%",
  marginLeft: 2,
  marginRight: 2,
};

export const requestReview = { display: "flex", flexDirection: "row", minWidth: "50%" }

export const rightSideDivider = {
  borderRight: `1px solid ${colors.borders[1]}`,
  verticalAlign: "top",
};

export const disciplineDivider = {
  width: 220,
  minWidth: 220,
  maxWidth: 220,
  borderRight: `1px solid ${colors.borders[1]}`,
  verticalAlign: "top",
};

export const TableHeaderStyle2 = {
  borderBottom: "none",
  borderTop: "none",
  "& th:first-of-type": {
    borderBottom: "none",
    borderTop: "none",
  },
  "& th:last-of-type": {
    borderBottom: "none",
    borderTop: "none",
  },
  "& th": {
    borderBottom: "none",
    borderTop: "none",
  },
};

export const TableContainerStyle = { minWidth: "100%", padding: 2 };